// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#countryCode .nemo-select__menu .nemo-select__option:nth-child(3){border-bottom:2px solid #f0f2f4 !important}", ""]);
// Exports
module.exports = exports;
